<template>
  <div>

    <q-list v-if="fieldValue && fieldValue.incomes && fieldValue.incomes.length > 1" bordered padding class="rounded-borders q-mb-md">
      <template v-for="(place, place_index) in fieldValue.incomes"
                :key="place_index">
      <q-item clickable v-ripple  v-if="fieldValue.incomes[place_index].valid" active-class="bg-teal-1 text-grey-8" :active="place_index === index">
        <q-item-section avatar top>
          <q-avatar icon="s_place" color="grey" text-color="white" />
        </q-item-section>

        <q-item-section @click="selectIncome(place_index)">
          <q-item-label lines="1">{{types[fieldValue.incomes[place_index].type]}}</q-item-label>
          <q-item-label caption>${{parseFloat(fieldValue.incomes[place_index].income).toLocaleString('en-US')}}
            </q-item-label>
        </q-item-section>

        <q-item-section side @click.stop="confirmDeleteAlert(place_index)">
          <q-icon name="s_delete" color="amber"  />
        </q-item-section>
      </q-item>
      </template>
    </q-list>
    <div class="text-subtitle1 q-py-sm">Add any other income not covered previously (alimony, child support, or separate maintenance need not be revealed if the Borrower or Co-Borrower does not choose to have it considered for repaying this loan)</div>
    <template v-if="index !== null && fieldValue.incomes[index] !== undefined">
      <q-form
          @submit="onSubmit"
          ref="form"
      >
      <div class="full-width">
        <div class="row  ">
          <div class="col-12 col-md-6 q-px-sm q-py-sm ">
            <FieldSelect
                v-model="fieldValue.incomes[index].type"
                :field="{layout_injected_label: 'Income Type', label: 'Income Type', required: true, requiredText: null,
                options: types
                }"
                :hide_bottom_space="true"
            ></FieldSelect>
          </div>
          <div class="col-12 col-md-6 q-px-sm q-py-sm ">
            <FieldMoney
                v-model="fieldValue.incomes[index].income"
                :field="{layout_injected_label: 'Gross Monthly Income', label: 'Gross Monthly Income', required: true, requiredText: null, options: {}}"
            ></FieldMoney>
          </div>
        </div>

        <div class="row  ">
          <div class="col-12 q-py-sm q-ml-none col-md-12 q-gutter-sm q-gutter-y-md">


            <q-btn
                v-if="fieldValue.incomes.length > 1"
                class="mw-form-v2-btn-submit "
                :flat="!settings.theme.next.cs ? settings.theme.button.flat: null"
                :rounded="!settings.theme.next.cs ? settings.theme.button.rounded: null"
                :round="!settings.theme.next.cs ? settings.theme.button.round: null"

                :outline="true"
                :push="!settings.theme.next.cs ? settings.theme.button.push: null"
                :unelevated="!settings.theme.next.cs ? settings.theme.button.unelevated: true"
                :noCaps="!settings.theme.next.cs ? settings.theme.button.noCaps: null"
                :glossy="!settings.theme.next.cs ? settings.theme.button.glossy : null"
                :size="settings.theme.next.cs ? settings.theme.next.size : settings.theme.button.size"

                label="Remove this Income Entry" type="button" color="primary"
                :class="{'mw-form-v2-btn-next-cs':  settings.theme.next.cs}"
                @click="confirmDeleteAlert(index)"
            >
            </q-btn>

            <q-btn

                class="mw-form-v2-btn-submit "
                :flat="!settings.theme.next.cs ? settings.theme.button.flat: null"
                :rounded="!settings.theme.next.cs ? settings.theme.button.rounded: null"
                :round="!settings.theme.next.cs ? settings.theme.button.round: null"

                :outline="true"
                :push="!settings.theme.next.cs ? settings.theme.button.push: null"
                :unelevated="!settings.theme.next.cs ? settings.theme.button.unelevated: true"
                :noCaps="!settings.theme.next.cs ? settings.theme.button.noCaps: null"
                :glossy="!settings.theme.next.cs ? settings.theme.button.glossy : null"
                :size="settings.theme.next.cs ? settings.theme.next.size : settings.theme.button.size"

                label="Add Other Income" type="submit" color="primary"
                :class="{'mw-form-v2-btn-next-cs':  settings.theme.next.cs}"
            >
            </q-btn>

            <q-btn

                class="mw-form-v2-btn-submit "
                :flat="!settings.theme.next.cs ? settings.theme.button.flat: null"
                :rounded="!settings.theme.next.cs ? settings.theme.button.rounded: null"
                :round="!settings.theme.next.cs ? settings.theme.button.round: null"
                color="black"
                :outline="true"
                :push="!settings.theme.next.cs ? settings.theme.button.push: null"
                :unelevated="!settings.theme.next.cs ? settings.theme.button.unelevated: true"
                :noCaps="!settings.theme.next.cs ? settings.theme.button.noCaps: null"
                :glossy="!settings.theme.next.cs ? settings.theme.button.glossy : null"
                :size="settings.theme.next.cs ? settings.theme.next.size : settings.theme.button.size"

                label="I have no other income" type="button"
                :class="{'mw-form-v2-btn-next-cs':  settings.theme.next.cs}"
                @click="noSourceOfIncome()"
            >
            </q-btn>


          </div>
        </div>
      </div>
      </q-form>
    </template>

    <q-field class="field_no_bottom_line" :hide-bottom-space="true"   :rules="[val => isValid() || 'Must Enter at least one other income']">
    </q-field>

    <q-dialog v-model="confirm" persistent>
      <q-card>
        <q-card-section class="row   items-center">
          <q-avatar icon="s_place" color="primary" text-color="white" />
          <span class="q-ml-sm">Switch to this income entry will clear a current item.</span>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="Cancel" color="primary" v-close-popup />
          <q-btn flat label="Confirm" @click="clearCurrentAndSwitch()" color="primary" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog v-model="confirmDelete" persistent>
      <q-card>
        <q-card-section class="row   items-center">
          <q-avatar icon="s_place" color="primary" text-color="white" />
          <span class="q-ml-sm">Are you sure to delete this income entry {{fieldValue.incomes[confirmDeleteIndex] && types[fieldValue.incomes[confirmDeleteIndex].type]}}?</span>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="Cancel" color="primary" v-close-popup />
          <q-btn flat label="Delete" @click="deleteItem()" color="primary" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import {mapFields} from "vuex-map-fields";
import FieldSelect from "@/components/fields/FieldSelect";
import FieldMoney from "@/components/fields/FieldMoney";

import {mapActions} from "vuex";
export default {
  components: {
    FieldSelect,
    FieldMoney
  },
  props: {
    modelValue: {},
    field:{}
  },
  data() {
    return {
      types: {
        'accessory_income': 'Accessory Unit Income',
        'alimony_child': 'Alimony/Child Support',
        'automobile': 'Automobile/Expense Account',
        'capital': 'Capital Gains',
        'related_assets': 'Employment Related Assets',
        'boarder': 'FNM Boarder Income',
        'credit_certificate': 'FNM Government Mortgage Credit Certificate',
        'foster_care': 'Foster Care',
        'voucher_program': 'Housing Choice Voucher Program (Section 8)',
        'military_base_pay': 'Military Base Pay',
        'military_clothes': 'Military Clothes Allowance',
        'military_combat': 'Military Combat Pay',
        'military_flight': 'Military Flight Pay',
        'military_hazard': 'Military Hazard Pay',
        'military_overseas': 'Military Overseas Pay',
        'military_prop': 'Military Prop Pay',
        'military_quarters': 'Military Quarters Allowance',
        'military_rations': 'Military Rations Allowance',
        'military_housing': 'Military Variable Housing Allowance',
        'non-borrower': 'Non-borrower Household Income',
        'installment': 'Notes Receivable/Installment',
        'other_types': 'Other Types Of Income',
        'pension_retirement': 'Pension/Retirement Income',
        'real_estate': 'Real Estate/Mortgage Differential',
        'royalty_payment': 'Royalty Payment',
        'seasonal_income': 'Seasonal Income',
        'social_security': 'Social Security/Disability Income',
        'temporary_leave': 'Temporary Leave',
        'tip_income': 'Tip Income',
        'trust_income': 'Trust Income',
        'unemployment': 'Unemployment/Public Assistance',
        'benefits': 'VA Benefits NonEducational',
        'interest': 'Dividends/Interest'
      },
        confirm: false,
        confirmIndex: null,
        confirmIndexToClear: null,
        confirmDelete: false,
        confirmDeleteIndex: null,
        income: {
          type: "",
          income: "",
          no_source_of_income: ""
        },
        incomes:[

        ],
        index: null
    };
  },
  emits: ['update:modelValue'],
  methods: {
    ...mapActions({
      nextScreen: 'values/list/nextScreen'
    }),
    noSourceOfIncome() {
      this.fieldValue.no_source_of_income = true;
      //this.fieldValue.incomes = [];
      this.nextScreen({form : this.form});
    },
    isValidIncome(index) {
      const income = this.fieldValue.incomes[index];
      return !(!income.type
          || !income.income
         );

    },
    isValid () {
      this.$refs.form.validate().then((success) => {
        this.fieldValue.incomes[this.index].valid = success;
      });
      return this.isValidIncome(this.index);
    },
    onSubmit() {
      this.fieldValue.incomes[this.index].valid = true;
      this.index = this.fieldValue.incomes.push(Object.assign({}, this.income)) - 1;
      this.$refs.form.reset();
    },
    selectIncome(place_index) {
      //this.$refs.form.resetValidation();
      this.confirmIndex = place_index;
      this.confirmIndexToClear = this.index;
      this.$refs.form.validate().then(success => {
        if (success) {
          this.index = place_index;
        }
        else {
          this.confirm = true;
        }
      });
    },
    clearCurrentAndSwitch() {
      this.$refs.form.reset();
      this.index = this.confirmIndex;
      this.fieldValue.incomes.splice(this.confirmIndexToClear, 1);
    },
    confirmDeleteAlert(index) {
      this.confirmDeleteIndex = index;
      this.confirmDelete = true;

    },
    deleteItem() {
      if(this.fieldValue.incomes.length === 1) {
        this.fieldValue.incomes.push(Object.assign({}, this.income));
      }
      this.fieldValue.incomes.splice(this.confirmDeleteIndex, 1);
      this.index = this.fieldValue.incomes.length -1;
    }
  },
  computed: {
    ...mapFields('settings/list', {
      settings: 'settings',
      form: 'form'
    }),
    requiredText: function () {
      return this.field.required_text ? this.field.required_text : 'Please select';
    },
    fieldValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    }
  },
  mounted() {
      if(this.fieldValue === undefined || this.fieldValue === null) {
        this.fieldValue = {
          incomes: [
            Object.assign({}, this.income)
          ]
        };
      }
      this.index = 0;
  }
}
</script>
<style>
.field_no_bottom_line .q-field__control:before {
  border-bottom-color: transparent !IMPORTANT;
}
.field_no_bottom_line  .q-field__control:after {
  background: none !important;
}
.field_no_bottom_line .q-field__control {
  display: none;
}
</style>
